import React from "react";
import { createEmployeeId, getFullMonthNameWithYear } from "@utils/utils";

const EmployeeDetail = ({
  machine_no,
  joining_date,
  employee_name,
  start_date,
  end_date,
}) => {
  return (
    <div style={wrapper}>
      <h6 style={textBold}>
        {`Employee ID: ${createEmployeeId(machine_no, joining_date)}`}
      </h6>
      <h6 style={textBold}>{`Employee Name: ${employee_name}`}</h6>
      <h6 style={textBold}>
        {`Payslip for the period: ${getFullMonthNameWithYear(
          start_date
        )} - ${getFullMonthNameWithYear(end_date)}`}
      </h6>
    </div>
  );
};

const wrapper = {
  marginTop: "15px",
};

const textBold = {
  fontWeight: "bold",
  fontSize: "15px",
};

export default EmployeeDetail;
